import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

export const exportDataToExcel = async (sheetsData, fileName) => {
  const workbook = new ExcelJS.Workbook();

  sheetsData.forEach((sheetData) => {
    const { sheetName, tables } = sheetData;
    const worksheet = workbook.addWorksheet(sheetName);

    let startRow = 1;
    let startColumn = "A";

    tables.forEach((tableData) => {
      const { title, data, columnStyles, headerNames } = tableData;

      if (title !== "") {
        //worksheet.mergeCells("A1:D1");
        const titleRow = worksheet.addRow([title]); // Add title row before data
        titleRow.getCell(1).font = {
          bold: true,
          size: 13,
          color: { argb: "1d428a" },
        };
        worksheet.addRow([]); // Add empty row between title and table
      } else {
        worksheet.addRow([]); // Add empty row between title and table
      }

      startRow += 2; // Increment startRow to account for title and empty row
      startRow = addTableToWorksheet(
        worksheet,
        data,
        startRow,
        startColumn,
        columnStyles,
        headerNames
      );
      startRow += 2; // Add an empty row between tables
      worksheet.addRow([]); // Add empty row between title and table
    });
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const date = new Date().toISOString().slice(0, 19).replace(/[-T:]/g, "");
  if (fileName) {
    saveAs(
      new Blob([buffer], { type: "application/octet-stream" }),
      `${fileName}.xlsx`
    );
  } else {
    saveAs(
      new Blob([buffer], { type: "application/octet-stream" }),
      `exported_data_${date}.xlsx`
    );
  }
};

export const addTableToWorksheet = (
  worksheet,
  data,
  startRow,
  startColumn,
  columnStyles,
  headerNames
) => {
  const columnKeys =
    data.length > 0 && data[0] !== null && typeof data[0] === "object"
      ? Object.keys(data[0])
      : [];

  const headers = headerNames.map((header) => header.title);
  const headerRow = worksheet.addRow(headers);

  headerRow.eachCell((cell, index) => {
    const { style = {}, width = 10 } = headerNames[index - 1] || {};

    cell.fill = style.fill || {};
    cell.font = style.font || {};
    cell.border = style.border || {};
    cell.alignment = style.alignment || {};

    const column = worksheet.getColumn(index);
    column.width = width;
  });

  const rowData =
    columnKeys.length === 0
      ? [
          Array(headerNames.length)
            .fill("")
            .map((value, index) => (index === 0 ? "No records found" : value)),
        ]
      : data.map((row) => columnKeys.map((key) => row[key]));

  rowData.forEach((row) => {
    const dataRow = worksheet.addRow(row);
    dataRow.eachCell((cell, index) => {
      const columnStyle = columnStyles[index - 1] || {};

      cell.font = columnStyle.font || {};
      cell.border = columnStyle.border || {};
      cell.alignment = columnStyle.alignment || {};
    });
  });

  return startRow + data.length + 2;
};
